import React from 'react';
import UiService from './../../../service/ui';

const DatePanel = ({ label, date, postFix = 'ago' }) => 
    <section> 
        { `${label} ${ UiService.timeSince(date, postFix) }` }
    </section>

export default DatePanel;